export default class BlockMiniFaq {
  constructor(container, options) {
      const defaultOptions = {
        mode: 'expanded',
        itemsOpen: 0,
        tabs: '.question-blocks-container .question-block'
      };

      this.options = Object.assign({}, defaultOptions, options);
      this.container = document.querySelector(container);
      this.tabs = this.container.querySelectorAll(this.options.tabs);
      this.itemsOpen = this.options.itemsOpen;

      this.setEvents();
      this.onLoad();
  }

  setEvents() {
      var self = this;
      this.tabs.forEach(tab => {
         tab.addEventListener('click', function() { self.clickTab(this); }); 
      });
  }
  
  onLoad() {
      var params = (new URL(document.location)).searchParams
      var id = params.get("show")

      if (id !== null) {
        this.filterMiniFaq(id);
      }

      for (let i = 0; i < this.itemsOpen && i < this.tabs.length; i++) {
        this.tabs[i].classList.add('show-block');
      }

      this.tabs.forEach(block => {
        block.addEventListener('click', () => {
          this.toggleAccordionBlock(block)
        })
      })
  }

  toggleAccordionBlock(clickedBlock) {
    this.tabs.forEach(block => {
      if (block === clickedBlock) {
        block.classList.toggle('show-block')
      } else {
        block.classList.remove('show-block')
      }
    })
  }
  
  showFirstTab() {
      this.clickTab(this.tabs[0]);
  }
  
  clickTab(elem) {
      this.filterMiniFaq();
  }
  
  filterMiniFaq(id) {
      this.tabs.forEach(tab => {
          if (tab.classList.contains('show')) {
              tab.classList.remove('show')
          } else {
              tab.classList.add('show')
          }

          if (tab.classList.contains(id)) {
              tab.classList.add('active')
          } else {
              tab.classList.remove('active')
          }
      })
  }
}